import { createSelector } from '@reduxjs/toolkit';
import { getSyiSlice } from 'tradera/apps/syi/state/selectors/syi';
import type { RootState } from 'tradera/state/configure-store';

export const selectIsUploadingFirstImage = createSelector(
    (state: RootState) => getSyiSlice(state).images.uploadingCount,
    (state: RootState) => getSyiSlice(state).images.images.length,
    (uploadingCount, imageCount) => uploadingCount > 0 && imageCount === 0,
);

export const selectImageIds = createSelector(
    (state: RootState) => getSyiSlice(state).images.images,
    (images) => images.map((image) => image.imageId),
);
